import Init from './classes/init';
import PopUpSlider from './classes/pop-up-slider';
import MediaSlider from './classes/media-slider';
import Chronology from './classes/chronology';
import MasonryGrid from './classes/masonry-grid';
import Main from './classes/main';
import HomeImages from './classes/home-images';

const siteFunctions = {
  test__ready() {
    // const { x, y, ...z } = { x: 1, y: 2, a: 3, b: 4 };
    // console.log(x); // 1
    // console.log(y); // 2
    // console.log(z); // { a: 3, b: 4 }
  },
  popUpSlider__ready() {
    const popUpSlider = new PopUpSlider();
    popUpSlider.init();
  },
  mediaSlider__ready() {
    const mediaSlider = new MediaSlider();
    mediaSlider.init();
  },
  chronology__ready() {
    const chronology = new Chronology();
    chronology.init();
  },
  main__ready() {
    const main = new Main();
    main.init();
  },
  masonryGrid__ready() {
    const masonry = new MasonryGrid();
    masonry.init();
  },

  homeImages__ready() {
    const homeImages = new HomeImages();
    homeImages.init();
  }
};

window.functionCore = new Init(siteFunctions);
